import { createFileRoute, redirect } from '@tanstack/react-router';

import { sessionQueries } from '@/api';
import { ProfilePage } from '@/features/profile/profile-page';

export const Route = createFileRoute('/profile')({
	beforeLoad: async ({ context }) => {
		const session = await context.queryClient.ensureQueryData(sessionQueries.current());
		if (!session) throw redirect({ to: '/login', search: { redirect: '/profile' } });
	},
	component: ProfilePage,
	staticData: { workspace: true },
});
